module.exports = __webpack_public_path__ + "static/img/hct4.4670d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hct/hct4.jpg
// module id = EhNY
// module chunks = 0